<template>
  <div>
    <b-container v-if="!getIsLoading">
      <b-row>
        <b-col cols="12" lg="12" md="12">
          <template-pillar-navigator :pillar-id="currentPillarId" />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="12" md="12">
          <template-indicator-navigator
            :pillar-id="currentPillarId"
            :indicator-id="currentIndicatorId"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="6">
          <card-indicator-info-gender-gap
            :pillar-id="currentPillarId"
            :indicator-id="currentIndicatorId"
            :height="'450px'"
          />
        </b-col>
        <b-col cols="12" lg="6">
          <card-chart-gauge-with-comment
            :pillar-id="currentPillarId"
            :indicator-id="currentIndicatorId"
            :alias="'gauge' + currentIndicatorId"
            :height="'450px'"
            @commentCreated="getIndicatorComments()"
          />
        </b-col>
      </b-row>
      <b-row
        v-if="comments && comments.length > 0 && (isIndicaUser || isPNUDADMIN)"
      >
        <b-col cols="12" lg="12">
          <b-card>
            <h4 class="card-title">
              {{ $t("label_reports_genderGap_comments") }}
            </h4>
            <div
              v-for="(comment, commentIndex) in comments"
              :key="commentIndex"
              style="white-space: pre-wrap"
            >
              {{ comment.comment
              }}<b-button
                size="sm"
                variant="link"
                class="mr-1"
                @click="openModal(comment, true)"
              >
                <img
                  src="../assets/images/edit_icon.svg"
                  style="width: 20px; height: 20px"
                />
              </b-button>
              <b-button
                size="sm"
                variant="link"
                class="mr-1"
                @click="openModal(comment, false)"
              >
                <img
                  src="../assets/images/delete_icon.svg"
                  style="width: 20px; height: 20px"
                />
              </b-button>
            </div>
            <b-modal v-model="showModal">
              <h5 style="margin-bottom: 20px">
                {{ $t("label_reports_genderGap_comments") }}
              </h5>
              <div v-if="!edit">
                {{ $t("label_reports_genderGap_comments_delete_confirmation")
                }}<br />{{ currentComment.comment }}
              </div>
              <div v-if="edit">
                {{ $t("label_reports_genderGap_comments_description") }}
              </div>

              <b-form-group v-if="edit" label-class="text-sm-left">
                <b-form-textarea
                  id="comment"
                  v-model="currentComment.comment"
                  type="text"
                  required
                />
              </b-form-group>

              <div slot="modal-footer" class="w-100" style="text-align: right">
                <b-button v-if="!edit" variant="primary" @click="saveComment()">
                  {{ $t("label_reports_comments_delete_button") }}
                </b-button>
                <b-button v-if="edit" variant="primary" @click="saveComment()">
                  {{ $t("label_evaluation_save_button") }}
                </b-button>
              </div>
            </b-modal>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="12">
          <card-charts-indicator
            :pillar-id="currentPillarId"
            :indicator-id="currentIndicatorId"
            :alias="'chart' + currentIndicatorId"
            height="450px"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="12">
          <card-conventions
            orientation="horizontal"
            :show-ideal="false"
            :show-company="false"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import CardChartGaugeWithComment from "./cards/CardChartGaugeWithComment";
import { createHelpers } from "vuex-map-fields";
import { axiosCall } from "@/utils/axiosCall";

const { mapFields } = createHelpers({
  getterType: "getUserAccountField",
  mutationType: "updateUserAccountField",
});

export default {
  name: "ReportsPillarGapIndicator",
  components: { CardChartGaugeWithComment },
  data: function () {
    return {
      gauge: [],
      indicatorsData: [],
      currentIndicator: {},
      paramsPillar: "",
      comments: [],
      edit: false,
      currentComment: {},
      showModal: false,
    };
  },
  computed: {
    ...mapGetters([
      "currentPillarId",
      "currentIndicatorId",
      "getCurrentSnapshot",
      "isPNUDADMIN",
      'isIndicaUser',
      'getIsLoading',
    ]),
    ...mapFields(["username"]),
  },
  methods: {
    saveComment: async function () {
      if (this.edit) {
        await axiosCall({
          url: "GenderGapReportComments",
          method: "PUT",
          data: this.currentComment,
        });
      } else {
        await axiosCall({
          url: "GenderGapReportComments/" + this.currentComment.id,
          method: "DELETE",
        });
      }
      this.showModal = false;
      await this.getIndicatorComments();
    },
    openModal(comment, edit) {
      this.edit = edit;
      this.currentComment = { ...comment };
      this.showModal = true;
    },
    ...mapMutations(["setCurrentPillarId", "setCurrentIndicatorId"]),
    getIndicatorComments: async function (indicator = "") {
      const where = { where: {} };
      where.where["snapshotId"] = this.getCurrentSnapshot.snapshotId;
      if (!indicator) {
        where.where["indicator_acronym"] = this.currentIndicatorId;
      } else {
        where.where["indicator_acronym"] = indicator;
      }
      console.log(where);
      await axiosCall({
        url: "GenderGapReportComments?filter=" + JSON.stringify(where),
        method: "GET",
      }).then((response) => {
        this.showModal = false;
        this.comments = response.data;
      });
    },
  },
  watch: {
    $route() {
      this.setCurrentPillarId(this.$route.params.pillar);
      this.setCurrentIndicatorId(this.$route.params.indicator);
      this.comments = [...[]];
      this.getIndicatorComments(this.$route.params.indicator);
    },
  },
  async created() {
    await this.$store.dispatch("SNAPSHOTS_GET");
    await this.$store.dispatch("BUSINESS_GET");
    await this.$store
      .dispatch("PILLARS_GET_REPORT")
      .then(() => {
        this.setCurrentPillarId(this.$route.params.pillar);
        this.setCurrentIndicatorId(this.$route.params.indicator);
      })
      .catch((err) => {
        console.log(err);
      });
    await this.getIndicatorComments();
  },
};
</script>

<style lang="sass" scoped>
h3
  font-size: 1.5rem
  margin-top: 40px

#ChartPillarContainer
  text-align: center

.col-5, .col-7
  padding-right: 5px
  padding-left: 5px
.col-8, .left
  padding-right: 5px
.col-4, .right
  padding-left: 5px
</style>
